import { connect } from "@formily/react";

export const Flex = connect((props) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: props.alignItems || "stretch",
        flexDirection: props.direction || "row",
        justifyContent: props.justifyContent || "flex-start",
        gap: 8,
        ...props.style, // allows override
      }}
      className={props.className}
    >
      {props.children}
    </div>
  );
});
